import { ButtonGroup, Card, CardBody, Col } from "reactstrap";
import DropdownInputs from "./DropdownInputs";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { DropdownWithInputTitle } from "../../../../Constants/Constants";
import { DropdownWithInputSubTitle } from "../../../../Data/UiKits/Dropdown";

const DropdownWithInput = () => {
  return (
    <Col xl="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={DropdownWithInputTitle} span={DropdownWithInputSubTitle} />
        <CardBody>
          <div className="common-flex">
            <ButtonGroup>
              <DropdownInputs />
            </ButtonGroup>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DropdownWithInput